import { emailTemplateSendGridMapper } from 'src/utils/mappers/emailTemplatesSendGridMapper';

import { CALL_API } from '../middleware/api';
import uniqueId from '../utils/uniqueId';

export const FETCHING_EMAIL_TEMPLATES_SEND_GRID = Symbol('FETCHING_EMAIL_TEMPLATES_SEND_GRID');
export const FETCHED_EMAIL_TEMPLATES_SEND_GRID_SUCCESS = Symbol('FETCHED_EMAIL_TEMPLATES_SEND_GRID_SUCCESS');
export const FETCHED_EMAIL_TEMPLATES_SEND_GRID_FAILURE = Symbol('FETCHED_EMAIL_TEMPLATES_SEND_GRID_FAILURE');

export const FETCHING_EMAIL_TEMPLATE_SEND_GRID = Symbol('FETCHING_EMAIL_TEMPLATE_SEND_GRID');
export const FETCHED_EMAIL_TEMPLATE_SEND_GRID_SUCCESS = Symbol('FETCHED_EMAIL_TEMPLATE_SEND_GRID_SUCCESS');
export const FETCHED_EMAIL_TEMPLATE_SEND_GRID_FAILURE = Symbol('FETCHED_EMAIL_TEMPLATE_SEND_GRID_FAILURE');

export const CREATE_EMAIL_TEMPLATE_SEND_GRID_SUCCESS = Symbol('CREATE_EMAIL_TEMPLATE_SEND_GRID_SUCCESS');

export const EMAIL_TEMPLATES_SEND_GRID_SORT = Symbol('EMAIL_TEMPLATES_SEND_GRID_SORT');

export const UPDATE_BUYER_FORM = 'UPDATE_BUYER_FORM';

export const UPDATE_FORM = 'UPDATE_FORM';

export const FETCHING_BUYER_SUGGESTIONS_START = 'FETCHING_BUYER_SUGGESTIONS_START';
export const FETCHING_BUYER_SUGGESTIONS_SUCCESS = 'FETCHING_BUYER_SUGGESTIONS_SUCCESS';

export const SET_DEFAULT_EDIT_TEMPLATE = 'SET_DEFAULT_EDIT_TEMPLATE';

export const DELETE_EMAIL_TEMPLATE_SEND_GRID_SUCCESS = 'DELETE_EMAIL_TEMPLATE_SEND_GRID_SUCCESS';

function updateForm({ key, name, formName, formData }) {
  return {
    type: UPDATE_FORM,
    name,
    key,
    formName,
    formData,
  };
}

function updateBuyerForm({ formName, formData, name }) {
  return {
    name,
    type: UPDATE_BUYER_FORM,
    formName,
    formData,
  };
}

export function handleUpdateForm(data) {
  return function(dispatch) {
    dispatch(updateForm(data));
  };
}

export function handleUpdateBuyerForm(data) {
  return function(dispatch) {
    dispatch(updateBuyerForm(data));
  };
}

export function handleGetBuyerProjectNameSuggestion(buyerId, value, name, page = 1) {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/browse/buyers/${buyerId}/projects?like=${value}&page=${page}`,
      startType: FETCHING_BUYER_SUGGESTIONS_START,
      successType: FETCHING_BUYER_SUGGESTIONS_SUCCESS,
    },
    fieldName: 'project',
    name,
    value,
    next: page > 1,
    questId: uniqueId(),
  };
}

export function handleGetBuyerNameSuggestion(value, name, page = 1) {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/browse/buyer_names?like=${value}&page=${page}`,
      startType: FETCHING_BUYER_SUGGESTIONS_START,
      successType: FETCHING_BUYER_SUGGESTIONS_SUCCESS,
    },
    fieldName: 'buyer',
    name,
    value,
    next: page > 1,
    questId: uniqueId(),
  };
}

export function fetchEmailTemplatesSendGrid({ activity, buyerId, projectId, templateName }) {
  const query = {
    activity,
    buyer_id: buyerId,
    project_id: projectId,
    template_name: templateName,
  };

  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/email_templates`,
      query,
      startType: FETCHING_EMAIL_TEMPLATES_SEND_GRID,
      successType: FETCHED_EMAIL_TEMPLATES_SEND_GRID_SUCCESS,
      errorType: FETCHED_EMAIL_TEMPLATES_SEND_GRID_FAILURE,
    },
  };
}

export function fetchEmailTemplateSendGridById(idEmailTemplate) {
  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/email_templates/${idEmailTemplate}`,
      startType: FETCHING_EMAIL_TEMPLATE_SEND_GRID,
      successType: FETCHED_EMAIL_TEMPLATE_SEND_GRID_SUCCESS,
      errorType: FETCHED_EMAIL_TEMPLATE_SEND_GRID_FAILURE,
    },
  };
}

function setDefaultEditTemplate() {
  return {
    type: SET_DEFAULT_EDIT_TEMPLATE,
  };
}

export function handleSetDefaultEditTemplate(data) {
  return function(dispatch) {
    dispatch(setDefaultEditTemplate(data));
  };
}

export function uploadEmailTemplateSendGrid({
  activity,
  buyerId,
  projectId,
  templateName,
  file,
  htmlSource,
  idEmailTemplate,
  subject,
  fromName,
  fromEmail,
}) {
  const body = emailTemplateSendGridMapper({
    activity,
    buyerId,
    projectId,
    templateName,
    file,
    htmlSource,
    subject,
    fromName,
    fromEmail,
  });

  return {
    [CALL_API]: {
      method: 'post',
      path: `/api/v1/email_templates/${idEmailTemplate}`,
      body,
      successType: CREATE_EMAIL_TEMPLATE_SEND_GRID_SUCCESS,
      afterSuccess: ({ dispatch }) => {
        dispatch(fetchEmailTemplatesSendGrid({}));
      },
    },
  };
}

export function createEmailTemplateSendGrid({
  activity,
  buyerId,
  projectId,
  templateName,
  file,
  htmlSource,
  subject,
  fromName,
  fromEmail,
}) {
  const body = emailTemplateSendGridMapper({
    activity,
    buyerId,
    projectId,
    templateName,
    file,
    htmlSource,
    subject,
    fromName,
    fromEmail,
  });

  return {
    [CALL_API]: {
      method: 'post',
      path: '/api/v1/email_templates',
      body,
      successType: CREATE_EMAIL_TEMPLATE_SEND_GRID_SUCCESS,
      afterSuccess: ({ dispatch }) => {
        dispatch(fetchEmailTemplatesSendGrid({}));
      },
    },
  };
}

export function deleteEmailTemplateSendGrid(idEmailTemplate) {
  return {
    [CALL_API]: {
      method: 'delete',
      path: `/api/v1/email_templates/${idEmailTemplate}`,
      successType: DELETE_EMAIL_TEMPLATE_SEND_GRID_SUCCESS,
      afterSuccess: ({ dispatch }) => {
        dispatch(fetchEmailTemplatesSendGrid({}));
      },
    },
  };
}

export const sortEmailTemplatesSendGrid = field => ({ type: EMAIL_TEMPLATES_SEND_GRID_SORT, field });
